(function () {
  var page = document.querySelector('.sc-page');
  if (!page) return;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* gallery: thumbnails swap the main photo; on touch screens the main photo also swipes left and right */
  document.querySelectorAll('[data-sc-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-sc-main]');
    var count = g.querySelector('[data-sc-count]');
    var thumbs = g.querySelectorAll('[data-sc-thumb]');
    var row = g.querySelector('.sc-thumbs');
    var cur = 0;
    thumbs.forEach(function (t, i) { if (t.getAttribute('aria-current') === 'true') cur = i; });
    var show = function (i, dir) {
      var t = thumbs[i];
      if (!t) return;
      cur = i;
      main.src = t.dataset.src;
      main.alt = t.dataset.alt || '';
      main.classList.toggle('sc-photo', t.dataset.kind === 'photo');
      if (count) count.textContent = t.dataset.i + ' / ' + thumbs.length;
      thumbs.forEach(function (o) { o.removeAttribute('aria-current'); });
      t.setAttribute('aria-current', 'true');
      /* keep the chosen thumbnail in view inside its own row (never scrolls the page) */
      if (row && row.scrollWidth > row.clientWidth) {
        row.scrollLeft = Math.max(0, t.offsetLeft - (row.clientWidth - t.offsetWidth) / 2);
      }
      if (dir && !reduce) {
        main.classList.remove('sc-in-r', 'sc-in-l');
        void main.offsetWidth;
        main.classList.add(dir > 0 ? 'sc-in-r' : 'sc-in-l');
      }
    };
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i, i > cur ? 1 : -1); });
    });
    if (thumbs.length > 1) {
      var sx = 0, sy = 0, tracking = false;
      g.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1 || e.target.closest('.sc-thumbs')) { tracking = false; return; }
        tracking = true; sx = e.touches[0].clientX; sy = e.touches[0].clientY;
      }, { passive: true });
      g.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) {
          var n = cur + (dx < 0 ? 1 : -1);
          if (n >= 0 && n < thumbs.length) show(n, dx < 0 ? 1 : -1);
        }
      }, { passive: true });
      g.addEventListener('touchcancel', function () { tracking = false; }, { passive: true });
    }
  });

  /* countdown in the banner */
  var banner = document.querySelector('[data-sc-countdown]');
  var raw = banner && banner.getAttribute('data-sc-countdown');
  if (raw) {
    var p = raw.split('-');
    var target = new Date(+p[0], (+p[1] || 1) - 1, +p[2] || 1, 9, 0, 0);
    var tick = function () {
      var ms = target - new Date(), t;
      if (ms <= 0) { t = 'now'; }
      else {
        var d = Math.floor(ms / 864e5), h = Math.floor(ms % 864e5 / 36e5), m = Math.floor(ms % 36e5 / 6e4);
        t = d + 'd ' + h + 'h ' + ('0' + m).slice(-2) + 'm';
      }
      document.querySelectorAll('.sc-cd').forEach(function (e) { e.textContent = t; });
    };
    tick();
    setInterval(tick, 30000);
  }

  /* sticky buy bar: shows once the buy box has scrolled out of view */
  var buy = document.querySelector('[data-sc-buy]');
  var bar = document.querySelector('[data-sc-buybar]');
  if (buy && bar) {
    var link = bar.querySelector('[data-sc-bar-link]');
    var raf = 0;
    var update = function () {
      raf = 0;
      var r = buy.getBoundingClientRect();
      var max = document.documentElement.scrollHeight - innerHeight;
      var on = r.bottom < 80 && scrollY < max - 200;
      bar.classList.toggle('sc-on', on);
      bar.setAttribute('aria-hidden', String(!on));
      if (link) link.tabIndex = on ? 0 : -1;
    };
    var onScroll = function () { if (!raf) raf = requestAnimationFrame(update); };
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll);
    update();
    if (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        buy.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      });
    }
  }

  /* green ball pointer (desktop only, never inside the theme editor). The normal arrow always stays visible. */
  var inEditor = window.Shopify && window.Shopify.designMode;
  if (!inEditor && window.matchMedia && matchMedia('(hover:hover) and (pointer:fine)').matches && !reduce) {
    var cur = document.createElement('div');
    cur.className = 'sc-cur';
    cur.setAttribute('aria-hidden', 'true');
    document.body.appendChild(cur);
    var x = 0, y = 0, cx = 0, cy = 0, running = false;
    var loop = function () {
      cx += (x - cx) * 0.35;
      cy += (y - cy) * 0.35;
      cur.style.transform = 'translate(' + cx + 'px,' + cy + 'px)';
      if (Math.abs(x - cx) > 0.1 || Math.abs(y - cy) > 0.1) requestAnimationFrame(loop);
      else running = false;
    };
    addEventListener('mousemove', function (e) {
      x = e.clientX; y = e.clientY;
      cur.classList.add('sc-on');
      if (!running) { running = true; requestAnimationFrame(loop); }
    });
    document.addEventListener('mouseleave', function () { cur.classList.remove('sc-on'); });
    document.addEventListener('mouseover', function (e) {
      cur.classList.toggle('sc-big', !!e.target.closest('a,button,summary,.sc-thumbs'));
    });
  }
  /* buy button: always buys exactly one bag. Any earlier cart is cleared first, so repeat clicks never stack up. */
  var buyForms = [];
  document.querySelectorAll('[data-sc-buy-button]').forEach(function (btn) {
    var f = btn.closest('form');
    if (f && buyForms.indexOf(f) < 0) buyForms.push(f);
  });
  buyForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (form.getAttribute('data-sc-busy')) return;
      form.setAttribute('data-sc-busy', '1');
      var idField = form.querySelector('[name=id]');
      var json = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
      var fallback = function () { form.removeAttribute('data-sc-busy'); form.submit(); };
      var errBox = form.querySelector('[data-sc-err]');
      if (errBox) errBox.hidden = true;
      var qtyField = form.querySelector('[name=quantity]');
      var qty = Math.max(1, parseInt(qtyField && qtyField.value, 10) || 1);
      fetch('/cart/clear.js', { method: 'POST', headers: json })
        .then(function (r) {
          if (!r.ok) throw new Error('clear');
          return fetch('/cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ id: Number(idField.value), quantity: qty }) });
        })
        .then(function (r) {
          if (r.status === 422) {
            var msg = "Sorry, we don't have that many left. Try a smaller number.";
            return r.json().then(function (j) { return (j && j.description) || msg; }, function () { return msg; }).then(function (m) {
              if (errBox) { errBox.textContent = m; errBox.hidden = false; }
              form.removeAttribute('data-sc-busy');
              throw 'handled';
            });
          }
          if (!r.ok) throw new Error('add');
          window.location.href = '/checkout';
        })
        .catch(function (e) { if (e !== 'handled') fallback(); });
    });
  });
  window.addEventListener('pageshow', function () {
    buyForms.forEach(function (f) { f.removeAttribute('data-sc-busy'); });
  });
  /* quantity picker: keeps the hidden field and the button price in step */
  document.querySelectorAll('[data-sc-qty]').forEach(function (box) {
    var form = box.closest('form');
    var field = form.querySelector('[name=quantity]');
    var out = box.querySelector('[data-sc-qty-out]');
    var minus = box.querySelector('[data-sc-qty-minus]');
    var plus = box.querySelector('[data-sc-qty-plus]');
    var priceEl = form.querySelector('[data-sc-btn-price]');
    var max = parseInt(box.getAttribute('data-max'), 10) || 10;
    var set = function (n) {
      n = Math.min(max, Math.max(1, n));
      field.value = n;
      out.textContent = n;
      minus.disabled = n <= 1;
      plus.disabled = n >= max;
      if (priceEl) {
        var unit = parseInt(priceEl.getAttribute('data-unit'), 10);
        var total = unit * n;
        try {
          priceEl.textContent = new Intl.NumberFormat('en-GB', {
            style: 'currency', currency: priceEl.getAttribute('data-currency') || 'GBP',
            minimumFractionDigits: total % 100 === 0 ? 0 : 2
          }).format(total / 100);
        } catch (e) { /* keep the text that is there */ }
      }
    };
    minus.addEventListener('click', function () { set((parseInt(field.value, 10) || 1) - 1); });
    plus.addEventListener('click', function () { set((parseInt(field.value, 10) || 1) + 1); });
    window.addEventListener('pageshow', function () { set(1); });
    set(1);
  });
})();
